/** Scenario 5's service levels: the same toll revenue buying 10, 25 or 50% more departures.
 *  In a pack, a level other than the default is a scenario of its own (pricing-transit-10,
 *  pricing-transit-25) carrying variant_of and service_level; the scenario it varies carries
 *  neither and is the default level. Every page that shows scenario 5 shares one level. */

export const DEFAULT_SERVICE_LEVEL = 0.5;

export const levelText = (level) => `+${Math.round(level * 100)}%`;

/** The level a pack scenario stands for. */
export const levelOf = (s) => (s.variant_of ? s.service_level : DEFAULT_SERVICE_LEVEL);

/** The pack scenario `baseId` at each of its service levels, [{ level, scenario }] from the
 *  lowest; null for a scenario without variants. */
export function packLevels(scenarios, baseId) {
  const base = scenarios.find((s) => s.id === baseId);
  const variants = scenarios.filter((s) => s.variant_of === baseId);
  if (!base || !variants.length) return null;
  return [base, ...variants].map((s) => ({ level: levelOf(s), scenario: s })).sort((a, b) => a.level - b.level);
}

/** The id of the scenario `baseId` at `level`: its variant there, else itself. */
export function idAtLevel(scenarios, baseId, level) {
  const v = scenarios.find((s) => s.variant_of === baseId && s.service_level === level);
  return v ? v.id : baseId;
}

/** transit_rank.py's ranking at a level: the lines the tolls buy and what they cost. */
export const rankUrl = (level) => (level === DEFAULT_SERVICE_LEVEL
  ? '/data/transit/scenario5/transit_rank.json'
  : `/data/transit/scenario5/boost${Math.round(level * 100)}/transit_rank.json`);
